import React, { useCallback, useEffect, useRef, useState } from 'react';

import { IToastItem } from './ToastItem';
import {
  ButtonClose,
  ButtonMore,
  Description,
  EndContent,
  IconStatus,
  MessageContainer,
  ProgressBar,
  ProgressLine,
  StartContent,
  Title,
  ToastCard,
} from './ToastItemElements';

const ToastItem = (props: IToastItem.IPropsToastItem) => {
  const ref = useRef<HTMLDivElement>(null);
  const refInterval = useRef<any>(null);
  const [withProgress, setWithProgress] = useState(100);

  const enqueueNext = useCallback(() => {
    if (!props.open) props.onClose();
  }, [props.open, props.onClose]);

  useEffect(() => {
    const snack = ref.current;
    snack?.addEventListener('animationend', enqueueNext);

    return () => {
      snack?.removeEventListener('animationend', enqueueNext);
    };
  }, [enqueueNext]);

  useEffect(() => {
    const chunk = 100 / (props.countdown / 1000);
    setWithProgress((state) => state - chunk / 2);
    refInterval.current = setInterval(() => {
      setWithProgress((state) => state - chunk);
    }, 1000);
    return () => {
      clearInterval(refInterval.current);
    };
  }, []);

  return (
    <ToastCard ref={ref} open={props.open} variant={props.variant} direction={props.direction}>
      <StartContent>
        <IconStatus
          className={props.variant === 'success' ? 'icon-Check' : 'icon-warning-1'}
          variant={props.variant}
        />
        <MessageContainer>
          <Title>{props.title}</Title>
          <Description>{props.message}</Description>
        </MessageContainer>
      </StartContent>
      <EndContent>
        {props.moreTitle && <ButtonMore onClick={props.moreOnClick}>{props.moreTitle}</ButtonMore>}
        <ButtonClose className={'icon-Close-Outline'} onClick={props.onDismiss} />
      </EndContent>
      <ProgressBar>
        <ProgressLine width={withProgress} />
      </ProgressBar>
    </ToastCard>
  );
};

ToastItem.defaultProps = {
  open: false,
  title: '',
  message: '',
  moreTitle: '',
  moreOnClick: () => null,
  variant: 'success',
  direction: 'left',
  onClose: () => null,
  onDismiss: () => null,
};

export { ToastItem };
